import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class AvatarComponent extends Component {
  @service store;
  @service currentUser;

  get person() {
    if (this.args.id) return this.store.peekRecord('person', this.args.id);
    return null;
  }

  get color() {
    const colorClass = this.person?.color ?? this.args?.meColor;
    if (colorClass) return `bg-${colorClass}-100`;
    return 'bg-indigo-600';
  }

  get abbreviation() {
    return this.person?.abbreviation ?? this.args?.abbreviation;
  }

  get name() {
    return this.person?.name ?? this.args?.meName;
  }

  get propsExist() {
    if (this.args.id) return true;
    if (this.args.meName !== undefined) return true;
    return false;
  }
}
